import { useState } from "react";
import { C } from "../utils/tokens";
import { Tag, Btn, Card, Field, FInput } from "../components/primitives";
import { onlyNumbers, validateAnno, validateVoto } from "../utils/validation";

const ErrMsg = ({ msg }) =>
  msg ? (
    <div style={{ fontSize: 11, color: C.danger, marginTop: 3 }}>{msg}</div>
  ) : null;

const Step3 = ({ d, s }) => {
  const [errors, setErrors] = useState({});
  const add = () =>
    s([...d, { id: Date.now(), istituto: "", titolo: "", anno: "", voto: "" }]);
  const u = (id, k, v) => s(d.map((e) => (e.id === id ? { ...e, [k]: v } : e)));
  const del = (id) => s(d.filter((e) => e.id !== id));

  const blurField = (id, key, validator, val) =>
    setErrors((e) => ({ ...e, [`${id}_${key}`]: validator(val) }));

  return (
    <div
      style={{ display: "flex", flexDirection: "column", gap: 20 }}
      className="au"
    >
      <div>
        <h2
          style={{
            fontFamily: "'Syne',sans-serif",
            fontSize: 26,
            fontWeight: 800,
            marginBottom: 5,
          }}
        >
          Formazione
        </h2>
        <p style={{ color: C.muted, fontSize: 13.5 }}>
          Lauree, diplomi, certificazioni, corsi.
        </p>
      </div>
      {d.map((e, i) => (
        <Card key={e.id}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 14,
            }}
          >
            <Tag>Titolo {i + 1}</Tag>
            {d.length > 1 && (
              <Btn size="sm" variant="danger" onClick={() => del(e.id)}>
                ✕
              </Btn>
            )}
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <Field label="Istituto">
              <FInput
                value={e.istituto}
                onChange={(v) => u(e.id, "istituto", v)}
                placeholder="Università di Roma, Liceo Scientifico..."
              />
            </Field>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "2fr 1fr 1fr",
                gap: 12,
              }}
            >
              <Field label="Titolo">
                <FInput
                  value={e.titolo}
                  onChange={(v) => u(e.id, "titolo", v)}
                  placeholder="Laurea Magistrale in..."
                />
              </Field>
              <Field label="Anno">
                <FInput
                  value={e.anno}
                  onChange={(v) => u(e.id, "anno", onlyNumbers(v).slice(0, 4))}
                  onBlur={() => blurField(e.id, "anno", validateAnno, e.anno)}
                  placeholder="2020"
                />
                <ErrMsg msg={errors[`${e.id}_anno`]} />
              </Field>
              <Field label="Voto (opz.)">
                <FInput
                  value={e.voto}
                  onChange={(v) => u(e.id, "voto", v.slice(0, 6))}
                  onBlur={() => blurField(e.id, "voto", validateVoto, e.voto)}
                  placeholder="110/110"
                />
                <ErrMsg msg={errors[`${e.id}_voto`]} />
              </Field>
            </div>
          </div>
        </Card>
      ))}
      <button
        onClick={add}
        style={{
          padding: 13,
          border: `1px dashed ${C.goldBorder}`,
          borderRadius: 10,
          background: C.goldDim,
          color: C.gold,
          fontSize: 13,
          fontFamily: "'Syne',sans-serif",
          transition: "all 0.18s",
          cursor: "pointer",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.borderColor = C.gold)}
        onMouseLeave={(e) => (e.currentTarget.style.borderColor = C.goldBorder)}
      >
        + Aggiungi titolo
      </button>
    </div>
  );
};

export default Step3;
